import { openEncryptedParams, sealEncryptedParams } from '@/utils/chat_entry_crypto';

const CHAT_SESSION_STORAGE_KEY = 'gx_chat_im_session';

export type ChatSessionStored = {
  SDKAppID: string;
  userID: string;
  userSig: string;
  token?: string;
  macAddress?: string;
  sourceUrl?: string;
  entryTimestamp?: string;
};

function sessionToPayload(data: ChatSessionStored): Record<string, string> {
  return {
    SDKAppID: data.SDKAppID,
    userID: data.userID,
    userSig: data.userSig,
    token: data.token ?? '',
    macAddress: data.macAddress ?? '',
    sourceUrl: data.sourceUrl ?? '',
    entryTimestamp: data.entryTimestamp ?? '',
  };
}

function payloadToSession(params: Record<string, string>): ChatSessionStored | null {
  const sdk =
    params.SDKAppID ?? params.SDKAppId ?? params.sdkAppID ?? params.sdkAppId;
  const uid =
    params.userID ??
    params.userId ??
    params.userid ??
    params.uid ??
    params.accountId ??
    params.accountID;
  const sig = params.userSig ?? params.usersig ?? params.userSIG;
  if (!sdk || !uid || !sig) {
    return null;
  }
  return {
    SDKAppID: sdk,
    userID: uid,
    userSig: sig,
    token: params.token || undefined,
    macAddress: params.macAddress || params.macaddress || undefined,
    sourceUrl: params.sourceUrl || params.source || undefined,
    entryTimestamp: params.entryTimestamp || undefined,
  };
}

function readLegacyPlainSession(raw: string): ChatSessionStored | null {
  try {
    const data = JSON.parse(raw) as ChatSessionStored;
    if (data.SDKAppID && data.userID && data.userSig) {
      return data;
    }
    return null;
  } catch {
    return null;
  }
}

export function readChatSession(): ChatSessionStored | null {
  try {
    const raw = sessionStorage.getItem(CHAT_SESSION_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const decrypted = openEncryptedParams(raw);
    if (decrypted) {
      return payloadToSession(decrypted);
    }
    return readLegacyPlainSession(raw);
  } catch {
    return null;
  }
}

export function writeChatSession(data: ChatSessionStored): void {
  const sealed = sealEncryptedParams(sessionToPayload(data));
  sessionStorage.setItem(CHAT_SESSION_STORAGE_KEY, sealed);
}
